import React from "react";
import styled from "styled-components";

/**
 * 数字カウント用の青丸バッジ（16px・青地白文字）。
 * count が 0 以下のときは何も描画しない。
 *
 * - 既定: インラインフローに乗る（スレッドの未読数、件数表示など）
 * - notification: 親要素（position: relative）の右上に重ねる絶対配置の
 *   通知バッジ（BottomAppBar のナビアイコンなど）
 */

const BaseBadge = styled.span`
  font-family: "A+mfCv-AXISラウンド 50 R StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;
  font-size: 8px;
  line-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: var(--soremo-blue);
  color: #fff;
  border-radius: 50%;
  border: 1px solid #fff;
  padding: 2px 0;
`;

const NotificationBadge = styled(BaseBadge)`
  position: absolute;
  top: -8px;
  right: 12px;
`;

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** バッジに表示するカウント。0 以下のときは描画しない */
  count: number;
  /** true で親要素の右上に重ねる通知バッジ（絶対配置）にする */
  notification?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  count,
  notification = false,
  ...rest
}) => {
  if (count <= 0) return null;

  const BadgeComponent = notification ? NotificationBadge : BaseBadge;

  return <BadgeComponent {...rest}>{count}</BadgeComponent>;
};

export default Badge;
